import type { InvestmentStatus } from '@/api/types';

interface StatusMeta {
  label: string;
  /** Tailwind classes for the badge – chrome colours, not data colours. */
  className: string;
  dot: string;
}

export const STATUS_META: Record<InvestmentStatus, StatusMeta> = {
  idea: {
    label: 'Idee',
    className: 'bg-slate-500/12 text-slate-600 dark:text-slate-300',
    dot: '#94a3b8',
  },
  planned: {
    label: 'Geplant',
    className: 'bg-blue-500/12 text-blue-700 dark:text-blue-300',
    dot: '#2a78d6',
  },
  quoted: {
    label: 'Angebot',
    className: 'bg-violet-500/12 text-violet-700 dark:text-violet-300',
    dot: '#4a3aa7',
  },
  ordered: {
    label: 'Beauftragt',
    className: 'bg-amber-500/14 text-amber-700 dark:text-amber-300',
    dot: '#eda100',
  },
  in_progress: {
    label: 'In Arbeit',
    className: 'bg-cyan-500/12 text-cyan-700 dark:text-cyan-300',
    dot: '#1baf7a',
  },
  done: {
    label: 'Erledigt',
    className: 'bg-emerald-500/14 text-emerald-700 dark:text-emerald-300',
    dot: '#0ca30c',
  },
  cancelled: {
    label: 'Verworfen',
    className: 'bg-rose-500/12 text-rose-700 dark:text-rose-300 line-through',
    dot: '#d03b3b',
  },
};

export const STATUS_ORDER: InvestmentStatus[] = [
  'idea',
  'planned',
  'quoted',
  'ordered',
  'in_progress',
  'done',
  'cancelled',
];

export const statusLabel = (status: InvestmentStatus): string => STATUS_META[status].label;
